import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { ApplicationError } from 'modules/core/lib/asyncAction'
import buildUrl from 'modules/core/lib/buildUrl'

interface Props {
  path: string
}

interface ReturnType {
  downloading: boolean
  onDownload: () => void
  error: boolean
  value: void | ApplicationError | null
}

const useDownloadTemplate = ({ path }: Props): ReturnType => {
  const {
    running: downloading,
    performAction: onDownload,
    error,
    value,
  } = useAsyncAction(
    async () => {
      window.location.href = buildUrl(path)
    },
    {
      successFlash: false,
    }
  )
  return {
    downloading,
    onDownload,
    error,
    value,
  }
}

export default useDownloadTemplate
